import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import GeralTable from "./ComputadoresTabela";
import APIAxios from "../../Api/APIAxios";
import Autocomplete from "@mui/material/Autocomplete";
import PageTitle from "../../Components/Layout/PageTitle";

const URL_SERVICE = "/computadores";

const ComputadoresListar = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(5); // Computadores
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const apiAxios = APIAxios();

  const [cmpSelecao, setCmpSelecao] = useState(20); // default: descrição
  const [registros, setRegistros] = useState([]);
  const [valorSelecionado, setValorSelecionado] = useState(""); // NOVO


  const handleListar = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);

    const response = await GetAPI(apiAxios, URL_SERVICE);
    setLoading(false);

    if (!response.success) {
      setAvisoErro(response.errorMessage);
    } else {
      setRegistros(response.data);
    }
  };

  useEffect(() => {
    handleListar();
  }, []);

  //Função para seleção de filtro
  const getAutocompleteOptions = () => {
    let options = [];

    switch (cmpSelecao) {
      case 10:
        options = registros.map((reg) => reg.pk.id);
        break;
      case 20:
        options = registros.map((reg) => reg.descricao);
        break;

      default:
        return [];
    }

    // Remove duplicados
    const uniqueOptions = [...new Set(options)];

    // Ordena de forma alfabética ou numérica
    return uniqueOptions.sort((a, b) => {
      if (typeof a === "string") return a.localeCompare(b); // ordenação alfabética
      return a - b; // ordenação numérica
    });
  };

  // NOVO: Filtra conforme o valor selecionado
  const registrosFiltrados = valorSelecionado
    ? registros.filter((reg) => {
      const valor = valorSelecionado.toLowerCase();
        switch (cmpSelecao) {
          case 10:
            return reg.pk.id.toString().includes(valorSelecionado);
          case 20:
            return reg.descricao.toLowerCase().includes(valor);

          default:
            return true;
        }
      })
    : registros;

  return (
    <Box>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Computadores"
        subtitle="Listagem de Computadores"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}

      <Box sx={{ color: "red", marginBottom: 2 }}>
        <Grid container spacing={2} alignItems={"center"}>
          {/*Usar meia tela em caso de monitor grande e tela total em monitores pequenos*/}
          <Grid item xs={12} md={3}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <FormControl fullWidth>
                <InputLabel>Filtrar por:</InputLabel>
                <Select
                  labelId="cmpSelecao"
                  id="cmpSelecao"
                  label="Filtrar por"
                  value={cmpSelecao}
                  onChange={(e) => setCmpSelecao(e.target.value)}
                >
                  <MenuItem value={10}>Computador</MenuItem>
                  <MenuItem value={20}>Descrição</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Autocomplete
              id="cmpDescricao"
              freeSolo
              options={getAutocompleteOptions()}
              value={valorSelecionado}
              onInputChange={(event, newValue) => setValorSelecionado(newValue)} // NOVO
              renderInput={(params) => (
                <TextField {...params} label="Localizar" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={3}></Grid>
        </Grid>
        <GeralTable
          registros={registrosFiltrados}
          setRegistros={setRegistros}
          setAvisoErro={setAvisoErro}
          setAvisoSucesso={setAvisoSucesso}
          setLoading={setLoading}
          handleListar={handleListar}
        />
      </Box>
    </Box>
  );
};

export default ComputadoresListar;
